import styled, { css } from "styled-components";

import { Tab, TabList, TabPanel, Tabs } from "@similarweb/ui-components";

import { aiAgentBoxBorderStroke } from "app/pages/sales-intelligence/modules/ai-agent/components";

export const StyledTabs = styled(Tabs)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
`;

export const StyledTabList = styled(TabList)<{ isVisible?: boolean }>`
    ${aiAgentBoxBorderStroke};

    display: ${({ isVisible = true }) => (isVisible ? "grid" : "none")};
    grid-template-columns: repeat(2, minmax(0, 1fr));

    margin: ${({ theme: { gapY, gapX } }) => css`
        ${gapY} ${gapX}
    `};
    padding: 3px;
    border-radius: 30px;
    box-sizing: border-box;
`;

export const StyledTab = styled(Tab).attrs<{ "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation-selected": selected,
}))`
    min-width: 0;
    padding: 0;

    &:after {
        display: none;
    }

    /* Override default react-tabs styles */

    & > div,
    & > div > div {
        min-width: 0;
        flex: 1;
    }
`;
StyledTab.tabsRole = "Tab";

// Dim the AI-prospecting tab while a demo is active; the tooltip wrapper keeps pointer events so the hover
// reason still shows. The mode switch itself is blocked in the container's select handler.
export const StyledDemoDisabledTab = styled.div<{ $isDisabled: boolean }>`
    display: flex;
    flex: 1;
    min-width: 0;
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
`;

export const StyledTabPanel = styled(TabPanel).attrs<{ "data-automation-selected"?: boolean }>(({ selected }) => ({
    "data-automation-selected": selected,
}))`
    min-height: 0;

    &.selected {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }
`;
